import { isOnboardingOwnTemplateAi } from '../constants/userExperiments'

export const METRIKA_COUNTER_ID = 94891161
export const REGISTER_FINISH_GOAL = 'register_finish'
export const PAYMENT_FINISH_GOAL = 'payment_finish'
export const NO_BUSINESS_SIGNING =
    'У меня нет бизнеса, я здесь чтобы подписать документ'

/** Онбординг первого договора. Идентификаторы — как заводить цели в Метрике. */
export const ONBOARDING_WIZARD_SHOWN = 'onboarding_wizard_shown'
export const ONBOARDING_PATH_DEMO = 'onboarding_path_demo'
export const ONBOARDING_PATH_WORD = 'onboarding_path_word'
export const ONBOARDING_PATH_CATALOG = 'onboarding_path_catalog'
export const ONBOARDING_PATH_GENERATE = 'onboarding_path_generate'
export const ONBOARDING_PATH_SKIP = 'onboarding_path_skip'
export const ONBOARDING_WORD_UPLOADED = 'onboarding_word_uploaded'
export const ONBOARDING_DEMO_SIGNED = 'onboarding_demo_signed'
export const ONBOARDING_TEMPLATE_READY = 'onboarding_template_ready'
export const ONBOARDING_OWN_CONTRACT = 'onboarding_own_contract'
export const ONBOARDING_PAY_OFFER_SHOWN = 'onboarding_pay_offer_shown'
export const ONBOARDING_PAY_OFFER_CTA = 'onboarding_pay_offer_cta'
export const ONBOARDING_PAY_OFFER_LATER = 'onboarding_pay_offer_later'

const ONBOARDING_ONCE_PREFIX = 'metrika_onboarding_'
const ONBOARDING_OWN_CONTRACT_STORAGE_KEY = `metrika_${ONBOARDING_OWN_CONTRACT}`

const PAYMENT_FINISH_STORAGE_PREFIX = 'metrika_payment_finish_'

function metrikaStorage(): Storage | null {
    try {
        if (typeof localStorage !== 'undefined') {
            return localStorage
        }
        if (typeof sessionStorage !== 'undefined') {
            return sessionStorage
        }
    } catch {
        // private mode
    }
    return null
}

export function trackGoal(goal: string, params: Object | null = null) {
    const ymFn = (globalThis as any).ym
    if (typeof ymFn !== 'function') {
        return
    }
    ymFn(METRIKA_COUNTER_ID, 'reachGoal', goal, params)
}

/** Один раз за вкладку, чтобы воронка не раздувалась от ререндеров. */
export function trackOnboardingGoal(goal: string, params: Object | null = null) {
    try {
        if (typeof sessionStorage !== 'undefined') {
            const key = `${ONBOARDING_ONCE_PREFIX}${goal}`
            if (sessionStorage.getItem(key)) {
                return
            }
            sessionStorage.setItem(key, '1')
        }
    } catch {
        // private mode
    }
    trackGoal(goal, params)
}

/** Свой (не демо) договор у когорты онбординга — один раз на браузер, без ?onboarding=1. */
export function shouldTrackOnboardingOwnContract(
    isDemo: boolean,
    experiments?: unknown,
): boolean {
    return !isDemo && isOnboardingOwnTemplateAi(experiments)
}

export function trackOnboardingOwnContract(
    isDemo: boolean,
    experiments?: unknown,
) {
    if (!shouldTrackOnboardingOwnContract(isDemo, experiments)) {
        return
    }
    const storage = metrikaStorage()
    try {
        if (storage?.getItem(ONBOARDING_OWN_CONTRACT_STORAGE_KEY)) {
            return
        }
        storage?.setItem(ONBOARDING_OWN_CONTRACT_STORAGE_KEY, '1')
    } catch {
        // private mode
    }
    trackGoal(ONBOARDING_OWN_CONTRACT)
}

/** Лид: самостоятельная регистрация с бизнесом. Подписание и «нет бизнеса» в цель не идут. */
export function shouldTrackRegisterFinish(
    contract: unknown,
    business?: unknown
): boolean {
    if (contract) {
        return false
    }
    return business !== NO_BUSINESS_SIGNING
}

export function trackRegisterFinish(contract: unknown, business?: unknown) {
    if (!shouldTrackRegisterFinish(contract, business)) {
        return
    }
    trackGoal(REGISTER_FINISH_GOAL)
}

export function trackPaymentFinish(
    transactionId?: string | null,
    params: Object | null = null
) {
    const id = transactionId || 'unknown'
    const key = `${PAYMENT_FINISH_STORAGE_PREFIX}${id}`
    const storage = metrikaStorage()
    try {
        if (storage?.getItem(key)) {
            return
        }
        storage?.setItem(key, '1')
    } catch {
        // private mode / недоступный storage
    }
    trackGoal(PAYMENT_FINISH_GOAL, params)
}

/** История транзакций не шлётся в Метрику — только факт оплаты через trackPaymentFinish. */
export function catchUpPaymentFinishFromHistory(_transactions?: unknown) {}
